import React from 'react'

import Box from '@mui/material/Box'
import Button from '@mui/material/Button'
import { useTheme } from '@mui/material/styles'
import { format } from 'date-fns'
import PropTypes from 'prop-types'

export const Day = ({ availability, day, onSelectDay, selectedDay }) => {
  const theme = useTheme()
  const today = new Date()
  const formattedDay = format(day, 'd')
  const month = format(day, 'MMMM')
  const isSelected =
    selectedDay &&
    format(day, 'yyyy-MM-dd') === format(selectedDay, 'yyyy-MM-dd')
  const isToday = format(day, 'yyyy-MM-dd') === format(today, 'yyyy-MM-dd')
  const hasAvailability = availability.times.length > 0

  return (
    <Box sx={{ position: 'relative' }}>
      <Button
        aria-label={`${month} ${formattedDay}`}
        color="primary"
        disabled={!hasAvailability}
        onClick={() => onSelectDay(day, availability)}
        sx={{
          borderRadius: '12px',
          minWidth: '40px',
          maxWidth: '40px',
          border: isToday ? '1px solid' : 'none',
          backgroundColor: isSelected
            ? theme.palette.primary.light
            : 'transparent',
          color: isSelected ? theme.palette.primary.contrastText : undefined,
          '&:disabled': {
            backgroundColor: 'transparent',
          },
        }}
        title={formattedDay}
        type="button"
        variant="text"
      >
        {formattedDay}
      </Button>
      {hasAvailability && (
        <Box
          data-testid="badge"
          sx={{
            backgroundColor: theme.palette.secondary.main,
            borderRadius: '50%',
            height: '8px',
            position: 'absolute',
            right: 0,
            top: 0,
            width: '8px',
          }}
        />
      )}
    </Box>
  )
}

Day.propTypes = {
  day: PropTypes.instanceOf(Date),
  availability: PropTypes.shape({
    date: PropTypes.string,
    times: PropTypes.array,
  }),
  onSelectDay: PropTypes.func,
  selectedDay: PropTypes.instanceOf(Date),
}
